export let manageArrayResponse = promise => {
  return promise;
};

export let manageObjectResponse = promise => {
  return promise;
};
